
const wx = (ajaxinstance) => {
  const wx = {}

  wx.getshare = (postData) => {
    // ajaxinstance.defaults.baseURL = ''
    return ajaxinstance.post('http://client.rup-china.com/icu/index.php/index/weixin/getshare', postData)
  }

  return wx
}

export default wx



// WEBPACK FOOTER //
// ./src/common/apis/wx.js